import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { getTecnicosToExcel } from "../../../services";
import { withRouter } from "../../../providers/withRouter";
import Excel from "../../../icons/excel.svg";
import { toast } from "react-toastify";

const ExportarListaTecnicos = ({ filtros }) => {
  const { t } = useTranslation(['common', 'properties']);
  const [isLoading, setIsLoading] = useState(false);
  const autoTriggered = useRef(false);

  // useEffect(() => {
  //   let fincas = [];
  //   let resultado = [];
  //   let aaff = [];
  //   let tech = [];
  //   let promises = [];
  //   promises.push(
  //     getFincasAAFF().then((res) => {
  //       console.log(res)
  //       fincas = res;
  //     }),
  //     getAllTecnicos().then((resT) => {
  //       tech = resT;
  //     })
  //   );

  //   Promise.all(promises).then(() => {
  //     tech.forEach((t) => {
  //       let data = {
  //         tech_id: t.id,
  //       };

  //       getAAFFs(data).then((res) => {
  //         console.log(res)
  //         let fincasPendientes = 0;
  //         let fincasVisitadas = 0;
  //         let fincasRenovadas = 0;
  //         let fincasRenovadasVisitadas = 0;
  //         let nfincas = 0;
  //         if (res.data.length === 0) {
  //           t.porcentaje = parseFloat(
  //             ((fincasVisitadas / (nfincas || 1)) * 100).toFixed(2)
  //           );
  //           t.fincasPendientes = fincasPendientes;
  //           t.estimacion =
  //             Math.round((fincasPendientes / 160 + Number.EPSILON) * 100) / 100;
  //           t.porcentajeRenovadas = parseFloat(
  //             (
  //               (fincasRenovadasVisitadas / (fincasRenovadasVisitadas || 1)) *
  //               100
  //             ).toFixed(2)
  //           );
  //           t.fincasRenovadas = fincasRenovadas;
  //           t.estimacionRenovadas =
  //             Math.round(
  //               (fincasRenovadasVisitadas / 160 + Number.EPSILON) * 100
  //             ) / 100;
  //           delete t.user;
  //           delete t.zona;
  //           delete t.id;
  //           delete t.apellidos;
  //         } else {
  //           res.data.forEach((a) => {
  //             fincas.map((f) => {
  //               if (a.nif == f.aaff?.nif) {
  //                 nfincas++;
  //                 if (f.visitada && !f.renovada && !f.renovadaVisitada) {
  //                   fincasVisitadas++;
  //                 }
  //                 if (f.renovada) {
  //                   fincasRenovadas++;
  //                 }
  //                 if (f.renovadaVisitada) {
  //                   fincasRenovadasVisitadas++;
  //                 }
  //                 if (!f.visitada) {
  //                   fincasPendientes++;
  //                 }
  //               }
  //             });
  //             t.nombre = t.nombre + " " + t.apellidos;
  //             t.porcentaje = parseFloat(
  //               ((fincasVisitadas / (nfincas || 1)) * 100).toFixed(2)
  //             );
  //             t.fincasPendientes = fincasPendientes;
  //             t.estimacion =
  //               Math.round((fincasPendientes / 160 + Number.EPSILON) * 100) /
  //               100;
  //             t.porcentajeRenovadas = parseFloat(
  //               (
  //                 (fincasRenovadasVisitadas / (fincasRenovadasVisitadas || 1)) *
  //                 100
  //               ).toFixed(2)
  //             );
  //             t.fincasRenovadas = fincasRenovadas;
  //             t.estimacionRenovadas =
  //               Math.round(
  //                 (fincasRenovadasVisitadas / 160 + Number.EPSILON) * 100
  //               ) / 100;
  //             delete t.user;
  //             delete t.zona;
  //             delete t.id;
  //             delete t.apellidos;
  //           });
  //         }
  //       });
  //       resultado.push(t);
  //       setTecnicos(resultado);
  //     });
  //   });
  // }, []);

  const exportar = async () => {
    setIsLoading(true);
    const toastId = toast.loading(t('properties:management.generatingList'));
    try {
      const data = await getTecnicosToExcel(filtros || {});
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${t('common:technicians.listFileName')}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.update(toastId, {
        render: t('properties:management.excelSuccess', 'Excel generado'),
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: t('properties:management.excelError', 'Error al generar el Excel'),
        type: 'error',
        isLoading: false,
        autoClose: 5000,
      });
    } finally {
      setIsLoading(false);
    // let totalPendientesVisitadas = pendientes + visitadas;
    // let totalRenovadasVisitadas = renovadas + renovadaVisitadas;

    // let porcentajePendientesVisitadas = (pendientes / totalPendientesVisitadas) * 100;
    // let porcentajeRenovadasVisitadas = (renovadas / totalRenovadasVisitadas) * 100;

    // console.log(`Pendientes: ${pendientes}`);
    // console.log(`Visitadas: ${visitadas}`);
    // console.log(`Renovadas: ${renovadas}`);
    // console.log(`Renovada Visitadas: ${renovadaVisitadas}`);
    // console.log(`Porcentaje de pendientes respecto a visitadas: ${porcentajePendientesVisitadas.toFixed(2)}%`);
    // console.log(`Porcentaje de renovadas respecto a renovada visitadas: ${porcentajeRenovadasVisitadas.toFixed(2)}%`);
    }
  };

  useEffect(() => {
    if (autoTriggered.current) return;
    autoTriggered.current = true;
    exportar();
  }, []);

  return (
    <button
      className={`bigBtn ${isLoading ? 'disabled' : ''}`}
      onClick={exportar}
      disabled={isLoading}
    >
      <img src={Excel} alt={t('properties:management.generateList')} width="30px" />
      {t('properties:management.generateList')}
    </button>
  );
};

export default withRouter(ExportarListaTecnicos);
